/* Fifty Five Produkt-Quiz – Etappe 3: Flow + Empfehlungslogik + Briefing + Warenkorb.
   Logik: docs/quiz/fifty-five-quiz-build-spec-v2.md · Copy: docs/quiz/fifty-five-quiz-copy-deck-v1.md
   Produktkacheln und Warenkorb-Formulare werden aus serverseitig gerenderten
   <template data-ff-quiz-card|-form> geklont – Add-to-Cart läuft über das
   ProductForm-Element des Themes (Drawer, cartUpdate, Fehlerbehandlung inklusive). */
(function () {
  'use strict';

  const root = document.querySelector('[data-ff-quiz]');
  const dataEl = document.querySelector('[data-ff-quiz-data]');
  if (!root || !dataEl) return;

  const T = JSON.parse(dataEl.textContent);

  // Der Liquid-t-Filter HTML-escaped Übersetzungen; wir rendern via textContent → einmal dekodieren
  (function decode(obj) {
    Object.keys(obj).forEach(function (k) {
      const v = obj[k];
      if (typeof v === 'string') {
        obj[k] = v.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
      } else if (v && typeof v === 'object') {
        decode(v);
      }
    });
  })(T);

  const PRODUCT_NAMES = { base: 'BASE', calm: 'CALM', rise: 'RISE', pulse: 'PULSE' };

  // Held je F1-Cluster (Build-Spec B/F1)
  const CLUSTER_HERO = { a: 'base', b: 'calm', c: 'rise', d: 'pulse', e: 'base' };

  // Held-Module je F2-Antwort (Build-Spec B/F2)
  const HERO_MODULES = {
    a1: ['ene_b', 'fat_b'],
    a2: ['fat_b', 'ene_b', 'gluc_cr'],
    a3: ['fat_b'],
    a4: ['fat_b', 'ene_b'],
    b1: ['nerv_mg', 'psy_mg'],
    b2: ['psy_mg', 'nerv_mg', 'horm_b6'],
    b3: ['musc_mg', 'nerv_mg'],
    b4: ['nerv_mg', 'psy_mg'], // bewusst KEINE Schlaf-Claims
    c1: ['imm_d'],
    c2: ['imm_d'],
    c3: ['imm_d'],
    c4: ['bone_dk'],
    d1: ['brain_dha'],
    d2: ['heart_o3'],
    d3: ['brain_dha', 'heart_o3'],
    d4: ['heart_o3'],
    e1: ['fat_b', 'imm_czs', 'oxid'],
    e2: ['ene_b', 'fat_b'],
    e3: ['imm_czs'],
    e4: ['fat_b', 'imm_czs']
  };

  // Fest verdrahtete Ergänzungen direkt aus dem F2-Pfad (Build-Spec B/F2)
  const PATH_SUPPLEMENT = {
    a3: { product: 'calm', modules: ['musc_mg', 'fat_mg'] },
    c1: { product: 'base', modules: ['imm_czs'] },
    c3: { product: 'base', modules: ['imm_czs'] },
    d4: { product: 'base', modules: ['oxid'] },
    e3: { product: 'rise', modules: ['imm_d'] }
  };

  // Alle nach Bestandteilen möglichen Claims je Produkt – nicht gezeigte werden
  // in der Claims-Box mit „Außerdem wissenschaftlich belegt" ergänzt
  // Alle belegten Wirkungen je Produkt: die wissenschaftliche Einordnung zeigt sie VOLLSTAENDIG (Georg),
  // die zum Pfad passenden zuerst. Modul-IDs = ff_quiz.claims.*
  const PRODUCT_CLAIMS = {
    base: ['fat_b', 'fat_c', 'ene_b', 'psy_b', 'imm_czs', 'oxid', 'gluc_cr', 'horm_b6'],
    calm: ['nerv_mg', 'psy_mg', 'musc_mg', 'fat_mg', 'ene_mg', 'horm_b6'],
    rise: ['imm_d', 'bone_dk', 'musc_d'],
    pulse: ['brain_dha', 'heart_o3']
  };

  // Welche Alltags-Angabe (F4) welches Produkt begruendet
  const REALITY_PRODUCT = { reality_sun: 'rise', reality_fish: 'pulse', reality_diet: 'base' };

  const F3_CANDIDATES = {
    sleep: { product: 'calm', module: 'nerv_mg' },
    stress: { product: 'calm', module: 'psy_mg' },
    immune: { product: 'rise', module: 'imm_d' },
    joints: { product: 'rise', module: 'bone_dk' },
    focus: { product: 'pulse', module: 'brain_dha' }
  };

  const REDUCED_MOTION = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ADVANCE_DELAY = REDUCED_MOTION ? 0 : 200;
  const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : function (fn) { fn(); };

  const state = {
    f1: null, sex: null, f2: null,
    f3: [], f4: { fish: null, sun: null, diet: null },
    f5: null, f6: null
  };
  let pendingAdvance = null;

  function hero() { return CLUSTER_HERO[state.f1] || null; }

  // Sichtbare Fragen-Sequenz – F5 nur weiblich, F6 nur wenn der Output sich ändern kann
  function sequence() {
    const seq = ['f1', 'f15', 'f2', 'f3', 'f4'];
    if (state.sex === 'f') seq.push('f5');
    if (hero() === 'base' && state.f5 !== 'preg') seq.push('f6');
    return seq;
  }

  function fill(template, vars) {
    return template.replace(/%([A-Z]+)%/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }

  // Tracking: CustomEvents (für Pixel/GTM-Listener) + GA4 über den dataLayer. Darf das Quiz nie brechen.
  // GA4 (2026-10-13): das gtag des Google-Kanals liest window.dataLayer der Seite mit (wie im Advertorial, geprüft
  // 2026-09-16). Nur die gtag-Aufrufform (arguments) trägt Parameter, und GA4 verwirft Namen mit „-“ oder „:“,
  // deshalb ff-quiz:step → ff_quiz_step. Leere Werte fallen weg.
  // Ereignisse vor der Einrichtung des Google-Tags (Start, Frage 1) verwirft gtag (live geprüft 2026-10-13). Deshalb
  // puffern, bis gtag dataLayer.push übernommen hat; das passiert erst nach Analytics-Einwilligung, also nie früher senden.
  const gaQueue = [];
  let gaTimer = null;
  function gaReady() {
    return Array.isArray(window.dataLayer) && window.dataLayer.push !== Array.prototype.push;
  }
  function gaFlush() {
    if (!gaReady()) return false;
    while (gaQueue.length) window.dataLayer.push(gaQueue.shift());
    if (gaTimer) { clearInterval(gaTimer); gaTimer = null; }
    return true;
  }
  function gtagPush() {
    gaQueue.push(arguments);
    if (gaFlush() || gaTimer) return;
    let tries = 0;
    gaTimer = setInterval(function () {
      if (gaFlush() || ++tries > 120) { clearInterval(gaTimer); gaTimer = null; }
    }, 500);
  }
  function track(eventName, detail) {
    try {
      if (typeof CustomEvent === 'function' && typeof document.dispatchEvent === 'function') {
        document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail || {} }));
      }
      if (typeof window === 'undefined') return;
      window.dataLayer = window.dataLayer || [];
      const params = {};
      Object.keys(detail || {}).forEach(function (k) {
        if (detail[k] != null && detail[k] !== '') params[k] = detail[k];
      });
      gtagPush('event', eventName.replace(/[^A-Za-z0-9]+/g, '_'), params);
    } catch (e) { /* bewusst still */ }
  }

  /* ---------------- Empfehlungslogik ---------------- */

  function computeResult() {
    // Override-Hierarchie: OR-PREG schlägt alles – kein Verkauf.
    if (state.f5 === 'preg') return { pregnancy: true };

    let heroProduct = hero();
    const f2id = state.f1 + state.f2;
    let heroModules = HERO_MODULES[f2id].slice();
    let supplement = null;

    if (PATH_SUPPLEMENT[f2id]) {
      supplement = {
        product: PATH_SUPPLEMENT[f2id].product,
        modules: PATH_SUPPLEMENT[f2id].modules.slice(),
        source: 'path'
      };
    }

    // F3: stärkstes Zweitthema, dessen Produkt ≠ Held – nie mehr als eine Ergänzung
    if (!supplement) {
      const tally = {};
      state.f3.forEach(function (id) {
        const c = F3_CANDIDATES[id];
        if (!c || c.product === heroProduct) return;
        if (!tally[c.product]) tally[c.product] = { count: 0, modules: [] };
        tally[c.product].count += 1;
        if (tally[c.product].modules.indexOf(c.module) === -1) tally[c.product].modules.push(c.module);
      });
      let best = null;
      ['calm', 'rise', 'pulse'].forEach(function (p) {
        if (tally[p] && (!best || tally[p].count > tally[best].count)) best = p;
      });
      if (best) supplement = { product: best, modules: tally[best].modules, source: 'f3' };
    }

    // F4: Alltags-Realität als ehrlicher Grund für eine Ergänzung
    if (!supplement) {
      if (state.f4.sun === 'low' && heroProduct !== 'rise') {
        supplement = { product: 'rise', modules: ['imm_d'], source: 'reality' };
      } else if ((state.f4.fish === 'rare' || state.f4.fish === 'never') && heroProduct !== 'pulse') {
        supplement = { product: 'pulse', modules: ['heart_o3', 'brain_dha'], source: 'reality' };
      } else if (state.f4.diet === 'poor' && heroProduct !== 'base') {
        supplement = { product: 'base', modules: ['imm_czs'], source: 'reality' };
      }
    }

    // F5 Wechseljahre: + HORM-B6, RISE/BONE-DK, Phasen-Framing, DIS-HORM
    const meno = state.f5 === 'meno';
    if (meno) {
      if (heroModules.indexOf('horm_b6') === -1) heroModules.push('horm_b6');
      if (heroProduct !== 'rise') {
        supplement = { product: 'rise', modules: ['bone_dk'], meno: true, source: 'meno' };
      } else if (heroModules.indexOf('bone_dk') === -1) {
        heroModules.push('bone_dk');
      }
    }

    // F6: Umlenkung statt Doppelverkauf (nur wenn Held = BASE und schon ein Multi da ist)
    let redirected = false;
    let covered = false;
    if (heroProduct === 'base' && state.f6 === 'multi') {
      if (supplement && supplement.product !== 'base') {
        heroProduct = supplement.product;
        heroModules = supplement.modules.slice();
        supplement = null;
        redirected = true;
      } else {
        covered = true; // keine erkennbare Lücke – bewusst nichts verkaufen
      }
    }

    // Alltags-Realität nur, wenn sie Held oder Ergänzung wirklich begründet
    const sp = supplement ? supplement.product : null;
    const reality = [];
    if ((heroProduct === 'rise' || sp === 'rise') && state.f4.sun === 'low') reality.push('reality_sun');
    if ((heroProduct === 'pulse' || sp === 'pulse') && (state.f4.fish === 'rare' || state.f4.fish === 'never')) reality.push('reality_fish');
    if ((heroProduct === 'base' || sp === 'base') && state.f4.diet === 'poor' && !covered) reality.push('reality_diet');

    // Ehrliche Einordnung: passend zum Symptompfad, OR-IRON bei Zyklus + Erschöpfung
    const honest = [];
    if (f2id === 'b4') honest.push('or_med_sleep');
    else if (state.f1 === 'a') honest.push('or_med_energy');
    else if (state.f1 === 'b') honest.push('or_med_calm');
    else if (state.f1 === 'c') honest.push('or_med_immune');
    if (state.f5 === 'cycle' && state.f1 === 'a') honest.push('or_iron');

    return {
      pregnancy: false,
      f2id: f2id,
      heroProduct: heroProduct,
      heroModules: heroModules,
      supplement: supplement,
      meno: meno,
      redirected: redirected,
      covered: covered,
      reality: reality,
      honest: honest
    };
  }

  /* ---------------- Rendering ---------------- */

  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // Theme-Button im Concept-Markup (.btn-fill/.btn-text + is=hover-button) –
  // ohne diese Struktur wird der Text beim Hover-Fill unsichtbar
  function themeButton(label, variant, opts) {
    opts = opts || {};
    const tag = opts.href ? 'a' : 'button';
    const isValue = opts.href ? 'hover-link' : 'hover-button';
    let b;
    try { b = document.createElement(tag, { is: isValue }); } catch (e) { b = document.createElement(tag); }
    b.setAttribute('is', isValue);
    if (opts.href) b.href = opts.href; else b.type = 'button';
    b.className = (opts.class ? opts.class + ' ' : '') + 'button ' + variant;
    const fillSpan = el('span', 'btn-fill');
    fillSpan.setAttribute('data-fill', '');
    b.appendChild(fillSpan);
    b.appendChild(el('span', 'btn-text', label));
    return b;
  }

  function clearRoot() {
    if (pendingAdvance) { clearTimeout(pendingAdvance); pendingAdvance = null; }
    while (root.firstChild) root.removeChild(root.firstChild);
  }

  function mountScreen(screen, focusEl) {
    screen.classList.add('ff-quiz-screen--enter');
    root.appendChild(screen);
    raf(function () {
      screen.classList.add('ff-quiz-screen--in');
      // Fokus auf die neue Überschrift: Screenreader lesen den Schritt vor,
      // Tastatur-Nutzer starten an der Frage statt am Seitenanfang
      if (focusEl && typeof focusEl.focus === 'function') {
        focusEl.setAttribute('tabindex', '-1');
        focusEl.focus({ preventScroll: true });
      }
    });
    if (firstRender) { firstRender = false; return; }
    root.scrollIntoView({ behavior: REDUCED_MOTION ? 'auto' : 'smooth', block: 'start' });
  }
  let firstRender = true;

  /* Farbdrift ("Die Farbe findet sich") am 2026-09-10 nach Georgs Test wieder entfernt: Die Richtung nach
     Frage 1 zu verraten nimmt der Auswertung Gewicht. Grund bleibt neutral; die Etikettenfarbe kommt erst
     im Ergebnis, im Produktblock. Die Stage traegt dort .is-result (Rechtszeile dann nicht mehr klebend). */
  const stage = root.closest('[data-ff-quiz-stage]') || root.parentElement;

  function questionDef(id) {
    switch (id) {
      case 'f1':
        return {
          type: 'single', key: 'f1', title: T.f1.title,
          options: ['a', 'b', 'c', 'd', 'e'].map(function (v) { return { v: v, label: T.f1['opt_' + v] }; })
        };
      case 'f15':
        return {
          type: 'single', key: 'sex', title: T.f15.title, context: T.f15.context,
          why: { label: T.f15.why_label, text: T.f15.why_text },
          options: [{ v: 'm', label: T.f15.male }, { v: 'f', label: T.f15.female }]
        };
      case 'f2': {
        const c = T['f2_' + state.f1];
        return {
          type: 'single', key: 'f2', title: c.title,
          options: ['1', '2', '3', '4'].map(function (v) { return { v: v, label: c['opt_' + v] }; })
        };
      }
      case 'f3':
        return {
          type: 'multi', title: T.f3.title, context: T.f3.hint,
          options: [
            { v: 'sleep', label: T.f3.opt_sleep }, { v: 'stress', label: T.f3.opt_stress },
            { v: 'immune', label: T.f3.opt_immune }, { v: 'joints', label: T.f3.opt_joints },
            { v: 'focus', label: T.f3.opt_focus }, { v: 'none', label: T.f3.opt_none, exclusive: true }
          ]
        };
      case 'f4':
        return {
          type: 'matrix', title: T.f4.title,
          groups: [
            { key: 'fish', label: T.f4.fish_label, options: [{ v: 'often', label: T.f4.fish_1 }, { v: 'rare', label: T.f4.fish_2 }, { v: 'never', label: T.f4.fish_3 }] },
            { key: 'sun', label: T.f4.sun_label, options: [{ v: 'high', label: T.f4.sun_1 }, { v: 'mid', label: T.f4.sun_2 }, { v: 'low', label: T.f4.sun_3 }] },
            { key: 'diet', label: T.f4.diet_label, options: [{ v: 'good', label: T.f4.diet_1 }, { v: 'mid', label: T.f4.diet_2 }, { v: 'poor', label: T.f4.diet_3 }] }
          ]
        };
      case 'f5':
        return {
          type: 'single', key: 'f5', title: T.f5.title,
          options: [
            { v: 'meno', label: T.f5.opt_meno }, { v: 'preg', label: T.f5.opt_preg },
            { v: 'cycle', label: T.f5.opt_cycle }, { v: 'none', label: T.f5.opt_none }
          ]
        };
      case 'f6':
        return {
          type: 'single', key: 'f6', title: T.f6.title,
          options: [
            { v: 'no', label: T.f6.opt_no }, { v: 'multi', label: T.f6.opt_multi },
            { v: 'single', label: T.f6.opt_single }, { v: 'unsure', label: T.f6.opt_unsure }
          ]
        };
    }
  }

  function isValid(id) {
    switch (id) {
      case 'f1': return !!state.f1;
      case 'f15': return !!state.sex;
      case 'f2': return !!state.f2;
      case 'f3': return state.f3.length > 0;
      case 'f4': return !!(state.f4.fish && state.f4.sun && state.f4.diet);
      case 'f5': return !!state.f5;
      case 'f6': return !!state.f6;
    }
    return false;
  }

  function setAnswer(key, value) {
    if (key === 'f1' && state.f1 !== value) state.f2 = null; // Cluster gewechselt → F2 verfällt
    if (key === 'sex' && value === 'm') state.f5 = null;     // F5 entfällt für Männer komplett
    state[key] = value;
  }

  function advance(fromId) {
    const s = sequence();
    const i = s.indexOf(fromId);
    if (i === s.length - 1) renderComputing();
    else renderQuestion(s[i + 1]);
  }

  // Ein Uebergang vor dem Ergebnis ("Wir gleichen deine Antworten ab"): inszeniert die Auswertung,
  // keine Wissens-Zwischenseiten (Georg: bei sechs Fragen affig).
  function renderComputing() {
    clearRoot();
    const screen = el('div', 'ff-quiz-screen ff-quiz-computing');
    const text = el('p', 'ff-quiz-computing-text', T.ui.computing || '');
    screen.appendChild(text);
    const dots = el('span', 'ff-quiz-computing-dots', '');
    dots.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 3; i++) dots.appendChild(el('i', '', ''));
    screen.appendChild(dots);
    mountScreen(screen, text);
    pendingAdvance = setTimeout(function () { pendingAdvance = null; finishQuiz(); }, REDUCED_MOTION ? 400 : 1600);
  }

  function scheduleAdvance(fromId) {
    if (pendingAdvance) clearTimeout(pendingAdvance);
    if (ADVANCE_DELAY === 0) { advance(fromId); return; }
    pendingAdvance = setTimeout(function () { pendingAdvance = null; advance(fromId); }, ADVANCE_DELAY);
  }

  function progressBar(id, seq) {
    const wrap = el('div', 'ff-quiz-progress');
    const idx = seq.indexOf(id);
    wrap.appendChild(el('p', 'ff-quiz-progress-label', fill(T.ui.progress, { C: String(idx + 1), T: String(seq.length) })));
    const track = el('div', 'ff-quiz-progress-track');
    const fillEl = el('span', 'ff-quiz-progress-fill');
    fillEl.style.width = Math.round(((idx + 1) / seq.length) * 100) + '%';
    track.appendChild(fillEl);
    wrap.appendChild(track);
    return wrap;
  }

  // Option-Button mit Radio- oder Checkbox-Indikator
  function optionButton(label, indicator) {
    const b = el('button', 'ff-quiz-option');
    b.type = 'button';
    b.appendChild(el('span', 'ff-quiz-indicator ff-quiz-indicator--' + indicator));
    b.appendChild(el('span', 'ff-quiz-option-label', label));
    return b;
  }

  function renderQuestion(id) {
    clearRoot();
    root.classList.remove('ff-quiz--result');
    if (stage) stage.classList.remove('is-result');
    const seq = sequence();
    track('ff-quiz:step', { step: id, index: seq.indexOf(id) + 1, total: seq.length, cluster: state.f1 });
    const def = questionDef(id);
    const screen = el('div', 'ff-quiz-screen');
    const titleId = 'ff-quiz-q-' + id;

    screen.appendChild(progressBar(id, seq));
    const title = el('h2', 'ff-quiz-question-title', def.title);
    title.id = titleId;
    screen.appendChild(title);
    if (def.context) screen.appendChild(el('p', 'ff-quiz-context', def.context));

    // Tap-to-reveal-Hinweis (nur wo ein Begriff Erklärung braucht, z. B. F1.5)
    if (def.why) {
      const whyId = titleId + '-why';
      const whyBtn = el('button', 'ff-quiz-whybtn', def.why.label);
      whyBtn.type = 'button';
      whyBtn.setAttribute('aria-expanded', 'false');
      whyBtn.setAttribute('aria-controls', whyId);
      const whyPanel = el('p', 'ff-quiz-why-panel', def.why.text);
      whyPanel.id = whyId;
      whyPanel.hidden = true;
      whyBtn.addEventListener('click', function () {
        whyPanel.hidden = !whyPanel.hidden;
        whyBtn.setAttribute('aria-expanded', whyPanel.hidden ? 'false' : 'true');
      });
      screen.appendChild(whyBtn);
      screen.appendChild(whyPanel);
    }

    let nextBtn = null;
    function refreshNext() { if (nextBtn) nextBtn.disabled = !isValid(id); }

    if (def.type === 'single') {
      // Auto-Advance: Antippen wählt aus und führt automatisch weiter
      const list = el('div', 'ff-quiz-options');
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-labelledby', titleId);
      const buttons = [];
      def.options.forEach(function (opt) {
        const b = optionButton(opt.label, 'radio');
        b.setAttribute('role', 'radio');
        const selected = state[def.key] === opt.v;
        b.setAttribute('aria-checked', selected ? 'true' : 'false');
        if (selected) b.classList.add('ff-quiz-option--selected');
        b.addEventListener('click', function () {
          setAnswer(def.key, opt.v);
          buttons.forEach(function (n, i) {
            const on = def.options[i].v === opt.v;
            n.classList.toggle('ff-quiz-option--selected', on);
            n.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          scheduleAdvance(id);
        });
        buttons.push(b);
        list.appendChild(b);
      });
      screen.appendChild(list);
    } else if (def.type === 'multi') {
      const list = el('div', 'ff-quiz-options');
      list.setAttribute('aria-labelledby', titleId);
      const buttons = [];
      function syncMulti() {
        buttons.forEach(function (n, i) {
          const on = state.f3.indexOf(def.options[i].v) !== -1;
          n.classList.toggle('ff-quiz-option--selected', on);
          n.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        refreshNext();
      }
      def.options.forEach(function (opt) {
        const b = optionButton(opt.label, 'check');
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          const idx = state.f3.indexOf(opt.v);
          if (idx !== -1) {
            state.f3.splice(idx, 1);
          } else {
            if (opt.exclusive) state.f3 = [];
            else state.f3 = state.f3.filter(function (v) { return v !== 'none'; });
            state.f3.push(opt.v);
          }
          syncMulti();
        });
        buttons.push(b);
        list.appendChild(b);
      });
      screen.appendChild(list);
      raf(syncMulti);
    } else if (def.type === 'matrix') {
      // Segmented Controls: ein ruhiger Schalter je Alltags-Thema
      def.groups.forEach(function (group) {
        const wrap = el('div', 'ff-quiz-group');
        const groupLabelId = titleId + '-' + group.key;
        const groupLabel = el('p', 'ff-quiz-group-label', group.label);
        groupLabel.id = groupLabelId;
        wrap.appendChild(groupLabel);
        const row = el('div', 'ff-quiz-segmented');
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-labelledby', groupLabelId);
        const buttons = [];
        group.options.forEach(function (opt) {
          const b = el('button', 'ff-quiz-segment', opt.label);
          b.type = 'button';
          b.setAttribute('role', 'radio');
          const selected = state.f4[group.key] === opt.v;
          b.setAttribute('aria-checked', selected ? 'true' : 'false');
          if (selected) b.classList.add('ff-quiz-segment--selected');
          b.addEventListener('click', function () {
            state.f4[group.key] = opt.v;
            buttons.forEach(function (n, i) {
              const on = group.options[i].v === opt.v;
              n.classList.toggle('ff-quiz-segment--selected', on);
              n.setAttribute('aria-checked', on ? 'true' : 'false');
            });
            refreshNext();
          });
          buttons.push(b);
          row.appendChild(b);
        });
        wrap.appendChild(row);
        screen.appendChild(wrap);
      });
    }

    const nav = el('div', 'ff-quiz-nav');
    const backBtn = el('button', 'ff-quiz-back', T.ui.back);
    backBtn.type = 'button';
    // Auf Frage 1 gibt es nichts, wohin "Zurueck" fuehren koennte (Georg): Button weg, Zeile bleibt fuer "Weiter".
    if (seq.indexOf(id) === 0) backBtn.hidden = true;
    backBtn.addEventListener('click', function () {
      const s = sequence();
      const i = s.indexOf(id);
      if (i <= 0) renderStart();
      else renderQuestion(s[i - 1]);
    });
    nav.appendChild(backBtn);

    // „Weiter" nur bei Mehrfachauswahl (F3) und Matrix (F4) – Single-Select advanced automatisch
    if (def.type === 'multi' || def.type === 'matrix') {
      nextBtn = themeButton(T.ui.next, 'button--primary', { class: 'ff-quiz-next' });
      nextBtn.addEventListener('click', function () { advance(id); });
      refreshNext();
      nav.appendChild(nextBtn);
    }

    screen.appendChild(nav);
    mountScreen(screen, title);
  }

  function block(labelText, modifier) {
    const b = el('section', 'ff-quiz-block' + (modifier ? ' ff-quiz-block--' + modifier : ''));
    if (labelText) b.appendChild(el('h3', 'ff-quiz-block-label', labelText));
    return b;
  }

  /* ---------------- Ergebnis-URL (Stufe 3, 2026-09-10) ----------------
     Antworten kompakt in ?r= (f1-sex-f2-f3a+f3b-fish-sun-diet-f5-f6). Damit ist das Ergebnis
     bookmark-/teilbar und die Klaviyo-Ergebnis-Mail kann genau diese Seite verlinken (ff_check_url). */
  function encodeState() {
    // Punkt als Trenner der Mehrfachauswahl: ein "+" liest URLSearchParams als Leerzeichen zurueck.
    return [state.f1, state.sex, state.f2, state.f3.join('.'), state.f4.fish, state.f4.sun, state.f4.diet, state.f5, state.f6]
      .map(function (v) { return v == null ? '' : String(v); }).join('-');
  }
  function decodeState(str) {
    const p = String(str || '').split('-');
    if (p.length < 7) return false;
    if (!/^[a-e]$/.test(p[0]) || !/^[mf]$/.test(p[1]) || !/^[1-4]$/.test(p[2])) return false;
    if (!/^(often|rare|never)$/.test(p[4]) || !/^(high|mid|low)$/.test(p[5]) || !/^(good|mid|poor)$/.test(p[6])) return false;
    const f3 = p[3] ? p[3].split(/[.+ ]/).filter(function (v) { return /^(sleep|stress|immune|joints|focus|none)$/.test(v); }) : [];
    if (!f3.length) return false;
    state.f1 = p[0]; state.sex = p[1]; state.f2 = p[2]; state.f3 = f3;
    state.f4 = { fish: p[4], sun: p[5], diet: p[6] };
    state.f5 = p[7] && /^(meno|preg|cycle|none)$/.test(p[7]) ? p[7] : null;
    state.f6 = p[8] && /^(no|multi|single|unsure)$/.test(p[8]) ? p[8] : null;
    return true;
  }
  function resultUrl() {
    try { const u = new URL(window.location.href); u.search = ''; u.searchParams.set('r', encodeState()); return u.toString(); } catch (e) { return window.location.href; }
  }
  function rememberResultUrl() {
    try { window.history.replaceState(null, '', resultUrl()); } catch (e) { /* still */ }
  }

  /* ---------------- E-Mail (Klaviyo Client-Subscriptions, DOI-Liste) ---------------- */
  function emailDone() {
    try { return sessionStorage.getItem('ffq_email') === '1'; } catch (e) { return false; }
  }
  function subscribe(email, r) {
    const K = T.klaviyo || {};
    if (!K.companyId || !K.listId || typeof fetch !== 'function') return Promise.reject(new Error('klaviyo not configured'));
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Bedarfs-Check',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  ff_check_cluster: state.f1 || null,
                  ff_check_path: state.f1 && state.f2 ? state.f1 + state.f2 : null,
                  ff_check_hero: r.heroProduct || null,
                  ff_check_supplement: r.supplement ? r.supplement.product : null,
                  ff_check_pregnancy: !!r.pregnancy,
                  ff_check_covered: !!r.covered,
                  ff_check_language: K.language || null,
                  ff_check_url: resultUrl()
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: K.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res || !res.ok) throw new Error('subscribe failed');
      try { sessionStorage.setItem('ffq_email', '1'); } catch (e) { /* egal */ }
      track('ff-quiz:email_signup', { cluster: state.f1, hero: r.heroProduct || null, pregnancy: !!r.pregnancy });
    });
  }

  // Floating-Label-Feld wie das Footer-Newsletter-Element (newsletter-form.liquid)
  function emailField(inputId, withSubmit) {
    const field = el('div', 'field relative');
    const input = el('input', 'input is-floating input--fill ff-quiz-email-input');
    input.type = 'email';
    input.id = inputId;
    input.setAttribute('placeholder', T.email.placeholder);
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('autocomplete', 'email');
    field.appendChild(input);
    const label = el('label', 'label is-floating', T.email.placeholder);
    label.setAttribute('for', inputId);
    field.appendChild(label);
    let btn = null;
    if (withSubmit) {
      const btnWrap = el('div', 'self-submit-button absolute');
      try { btn = document.createElement('button', { is: 'magnet-button' }); } catch (e) { btn = document.createElement('button'); }
      btn.setAttribute('is', 'magnet-button');
      btn.type = 'submit';
      btn.className = 'ff-quiz-email-submit button button--primary self-button flex justify-center items-center';
      btn.setAttribute('data-magnet', '20');
      btn.setAttribute('aria-label', T.email.submit);
      const btnText = el('span', 'btn-text');
      btnText.innerHTML = '<svg class="icon icon-arrow-right icon-xs transform" viewBox="0 0 16 16" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false"><path d="M1 8h14M8 1l7 7-7 7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.appendChild(btnText);
      btnWrap.appendChild(btn);
      field.appendChild(btnWrap);
    }
    return { field: field, input: input, button: btn };
  }

  function statusLine() {
    const status = el('p', 'ff-quiz-email-status');
    status.hidden = true;
    status.setAttribute('aria-live', 'polite');
    status.show = function (message, success) {
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('alert', true);
      status.classList.toggle('alert--success', !!success);
      status.classList.toggle('alert--error', !success);
    };
    return status;
  }

  // Optionaler E-Mail-Block am Ende des Ergebnisses (zweite Chance, wenn der Schritt davor uebersprungen wurde)
  function emailBlock(r, copy) {
    copy = copy || {};
    const K = T.klaviyo || {};
    if (!K.companyId || !K.listId || typeof fetch !== 'function' || emailDone()) return null;
    const wrap = block(copy.label || T.email.label, 'callout');
    wrap.appendChild(el('p', 'ff-quiz-text', copy.text || T.email.text));
    const f = emailField('FFQuizNewsletter', true);
    if (copy.submit && f.button) f.button.setAttribute('aria-label', copy.submit);
    wrap.appendChild(f.field);
    const status = statusLine();
    wrap.appendChild(status);
    function submit() {
      const email = (f.input.value || '').trim();
      if (!email || email.indexOf('@') === -1) { status.show(T.email.error, false); return; }
      f.button.setAttribute('aria-busy', 'true');
      subscribe(email, r).then(function () {
        f.button.removeAttribute('aria-busy');
        status.show(T.email.success, true);
        f.input.value = '';
      }).catch(function () {
        f.button.removeAttribute('aria-busy');
        status.show(T.email.error, false);
      });
    }
    f.button.addEventListener('click', submit);
    f.input.addEventListener('keydown', function (e) { if (e && e.key === 'Enter') submit(); });
    return wrap;
  }

  // Nach dem Uebergang: Ergebnis-URL merken, dann direkt das Ergebnis (der E-Mail-Zwischenschritt ist weg, Georg;
  // "Ergebnis speichern" steht am Ende der Seite)
  function finishQuiz() {
    rememberResultUrl();
    renderResult();
  }

  /* ---------------- Ergebnis (Runde 8, 2026-09-11): Georgs Aufbau ----------------
     Kopf (Eyebrow = Zahl der Fragen, "Dein Ergebnis"), Einstieg (wechselnder Auftakt + Auswertungstext +
     "Was oft dahintersteckt" aus dem Live-Check), Empfehlung als EIN Band in der Produktfarbe: Intro in
     Georgs Tenor, Foto, Produkterklaerung, Kaufbox mit Stufenwahl, Warum in Alltagssprache mit Zitat,
     wissenschaftliche Einordnung vollstaendig, Story. Empfehlung Nr. 2 im gleichen Aufbau (ohne Warum/
     Story), dann Ehrliche Einordnung, Abschluss (Ergebnis speichern | Nicht sicher als Textlinks),
     Disclaimer. Die Alltags-Angaben (F4) begruenden nur noch die Ergaenzung, nicht den Einstieg. */

  function module(eyebrow, headline, modifier) {
    const sec = el('section', 'ff-quiz-mod' + (modifier ? ' ff-quiz-mod--' + modifier : ''));
    if (eyebrow || headline) {
      const head = el('div', 'ff-quiz-mod-head');
      if (eyebrow) head.appendChild(el('p', 'ff-eyebrow', eyebrow));
      if (headline) head.appendChild(el('h3', 'ff-quiz-mod-title', headline));
      sec.appendChild(head);
    }
    return sec;
  }

  // Auftakt wechselt mit den Antworten (deterministisch je Ergebnis-URL): ein zweiter Durchlauf beginnt anders
  function openerFor() {
    const list = (T.result.opener || []).filter(Boolean);
    if (!list.length) return '';
    const str = encodeState();
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return list[h % list.length];
  }

  function stripScripts(node) {
    node.querySelectorAll('script').forEach(function (sc) { sc.remove(); });
    return node;
  }

  // Stufenwahl in der Kaufbox: eigene Initialisierung (das Inline-Skript des Snippets wird beim Klonen entfernt)
  function initTiers(root, onChange) {
    const box = root.querySelector('[data-ff-tiers]');
    if (!box) return;
    const qty = box.querySelector('[data-ff-tier-qty]');
    const sum = box.querySelector('[data-ff-tier-sum]');
    const total = box.querySelector('[data-ff-tier-total]');
    const original = box.querySelector('[data-ff-tier-original]');
    const save = box.querySelector('[data-ff-tier-save]');
    const radios = box.querySelectorAll('.ff-tiers__radio');
    const saveTpl = T.ui.tier_savings || '';
    function update() {
      radios.forEach(function (radio) {
        const opt = radio.closest('.ff-tiers__opt');
        if (opt) opt.classList.toggle('is-selected', radio.checked);
        if (!radio.checked) return;
        if (qty) qty.value = radio.value;
        const n = parseInt(radio.value, 10) || 1;
        if (sum && total) {
          if (n > 1) {
            total.textContent = radio.getAttribute('data-ff-total');
            if (original) original.textContent = radio.getAttribute('data-ff-regular');
            if (save) save.textContent = fill(saveTpl, { A: radio.getAttribute('data-ff-save') });
            sum.hidden = false;
          } else {
            sum.hidden = true;
          }
        }
        if (onChange) onChange(n);
      });
    }
    radios.forEach(function (radio) { radio.addEventListener('change', update); });
    update();
  }

  // Kaufbox = serverseitiges Template (Name, Fakten, Preis, Stufenwahl, product-form)
  function buyBox(productKey, role, onQty) {
    const tpl = document.querySelector('template[data-ff-quiz-buybox="' + productKey + '"]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    const node = stripScripts(tpl.content.cloneNode(true).firstElementChild);
    const formEl = node.querySelector('form');
    if (formEl) formEl.addEventListener('submit', function () { track('ff-quiz:add_to_cart', { product: productKey, role: role }); });
    initTiers(node, onQty);
    return node;
  }

  function photoFor(productKey) {
    const tpl = document.querySelector('template[data-ff-quiz-photo="' + productKey + '"]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    return tpl.content.cloneNode(true).firstElementChild;
  }

  // Vollstaendige Liste der belegten Wirkungen eines Produkts, die zum Pfad passenden zuerst
  function claimsList(productKey, firstModules) {
    const all = (PRODUCT_CLAIMS[productKey] || []).slice();
    const order = (firstModules || []).filter(function (m) { return all.indexOf(m) !== -1; });
    all.forEach(function (m) { if (order.indexOf(m) === -1) order.push(m); });
    const list = el('ul', 'ff-quiz-claims');
    order.forEach(function (mid) { if (T.claims[mid]) list.appendChild(el('li', 'ff-quiz-claim', T.claims[mid])); });
    return list;
  }

  // Hinleitung beim Held mit EFSA-Fussnote; bei Nr. 2 eine andere Hinleitung, die die EFSA selbst nennt (keine Dopplung)
  function scienceBlock(productKey, firstModules, secondary) {
    const RES = T.result;
    const sec = el('div', 'ff-quiz-science');
    sec.appendChild(el('h4', 'ff-quiz-subtitle', RES.chapter_science));
    const intro = secondary ? (RES.science_intro_add || RES.science_intro) : RES.science_intro;
    if (intro) sec.appendChild(el('p', 'ff-quiz-text', fill(intro, { P: PRODUCT_NAMES[productKey] })));
    sec.appendChild(claimsList(productKey, firstModules));
    if (!secondary && RES.efsa_note) sec.appendChild(el('p', 'ff-quiz-note', RES.efsa_note));
    return sec;
  }

  function quoteFor(key) {
    const tpl = document.querySelector('template[data-ff-quiz-quote="' + key + '"]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    const wrap = el('div', 'ff-quiz-voice');
    wrap.appendChild(tpl.content.cloneNode(true));
    return wrap;
  }

  function storyFor(key) {
    const tpl = document.querySelector('template[data-ff-quiz-story="' + key + '"]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    const node = tpl.content.cloneNode(true).firstElementChild;
    node.addEventListener('click', function () { track('ff-quiz:story_click', { product: key }); });
    return node;
  }

  // Das Daten-JSON traegt die Cluster-Texte als sys_a..sys_e (wie T.support['sys_' + state.f1] im Einstieg)
  const PRODUCT_SYS = { base: 'sys_e', calm: 'sys_b', rise: 'sys_c', pulse: 'sys_d' };

  // Warum <Produkt>: Alltagssprache je Pfad, dazu die Zweitthemen (F3) und Alltags-Angaben (F4), die das Produkt trifft, dann das Zitat
  function whyBlock(r, pathId) {
    const RES = T.result;
    const key = r.heroProduct;
    const wrap = el('div', 'ff-quiz-why');
    wrap.appendChild(el('h4', 'ff-quiz-subtitle', fill(RES.chapter_why || '', { P: PRODUCT_NAMES[key] })));
    let text = r.redirected ? (T.support[PRODUCT_SYS[key]] || '') : ((RES.why && RES.why[pathId]) || T.hero_intro[key] || '');
    const extra = [];
    // Bei Umlenkung traegt der Cluster-Text; ein eingeschobener Zweitthema-Satz haette dort keinen Anker
    if (!r.redirected) state.f3.forEach(function (v) {
      const c = F3_CANDIDATES[v];
      if (c && c.product === key && RES.why_f3 && RES.why_f3[v]) extra.push(RES.why_f3[v]);
    });
    // Zweitthemen vor dem letzten Satz, damit der letzte Satz des Warum-Textes weiter zum Zitat ueberleitet
    // (Georg: "Das bestaetigen auch andere" haengt am Abschalten). Abkuerzungen wie "I. E." nicht als Satzende werten.
    if (extra.length) {
      let cut = text.lastIndexOf('. ');
      while (cut > 0 && /(^|\s)[A-ZÄÖÜ]$/.test(text.slice(0, cut))) cut = text.lastIndexOf('. ', cut - 1);
      text = cut > 0 ? text.slice(0, cut + 1) + ' ' + extra.join(' ') + ' ' + text.slice(cut + 2) : text + ' ' + extra.join(' ');
    }
    const close = pathId === 'b4' && !r.redirected ? RES.why_close_b4 : RES.why_close;
    wrap.appendChild(el('p', 'ff-quiz-text ff-quiz-whytext', [text, close].filter(Boolean).join(' ')));
    const voice = quoteFor(key);
    if (voice) wrap.appendChild(voice);
    return wrap;
  }

  /* Ein Band in der Produktfarbe: Kopf, Intro, Foto neben der Erklaerung, Kaufbox, dann Warum, Einordnung, Story */
  function productBand(productKey, opts) {
    opts = opts || {};
    const RES = T.result;
    const name = PRODUCT_NAMES[productKey];
    const band = el('section', 'ff-quiz-band ff-quiz-band--' + productKey + (opts.secondary ? ' ff-quiz-band--add' : ''));
    const inner = el('div', 'ff-quiz-band-inner');
    const head = el('div', 'ff-quiz-mod-head');
    if (opts.eyebrow) head.appendChild(el('p', 'ff-eyebrow', opts.eyebrow));
    head.appendChild(el('h3', 'ff-quiz-mod-title', name));
    const tagline = T.tagline && T.tagline[productKey];
    if (tagline) head.appendChild(el('p', 'ff-quiz-mod-sub', tagline));
    inner.appendChild(head);
    if (opts.lead) inner.appendChild(el('p', 'ff-quiz-text ff-quiz-band-lead', opts.lead));
    const media = el('div', 'ff-quiz-band-media');
    const photo = photoFor(productKey);
    if (photo) media.appendChild(photo);
    const explain = el('div', 'ff-quiz-band-explain');
    if (RES.explain && RES.explain[productKey]) explain.appendChild(el('p', 'ff-quiz-text', RES.explain[productKey]));
    media.appendChild(explain);
    inner.appendChild(media);
    const box = buyBox(productKey, opts.secondary ? 'supplement' : 'hero', opts.onQty);
    if (box) { inner.appendChild(box); band.ffBuybox = box; }
    if (opts.why) inner.appendChild(opts.why);
    inner.appendChild(scienceBlock(productKey, opts.modules, !!opts.secondary));
    band.appendChild(inner);
    return band;
  }

  /* Mitlaufende Kauf-Pille: serverseitig gerendertes Markup der PDP (template[data-ff-quiz-sticky]),
     damit die Glas-Pille aus theme.css exakt so aussieht wie dort. Sichtbarkeit ueber die Vanilla-
     Klassen opacity-0/invisible, sobald die Kaufbox nach oben aus dem Bild ist. */
  function stickyBuy(productKey, anchor) {
    const tpl = document.querySelector('template[data-ff-quiz-sticky="' + productKey + '"]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    const bar = tpl.content.cloneNode(true).firstElementChild;
    const card = bar.querySelector('.product-sticky-form__card');
    const formEl = bar.querySelector('form');
    if (formEl) formEl.addEventListener('submit', function () { track('ff-quiz:add_to_cart', { product: productKey, role: 'sticky' }); });
    if (!card) return bar;
    function show(on) { card.classList.toggle('opacity-0', !on); card.classList.toggle('invisible', !on); }
    function check() { show(anchor.getBoundingClientRect().bottom < 0); }
    // IntersectionObserver meldet nur Uebergaenge: springt die Seite von unter- nach oberhalb der Kaufbox
    // (Textlink, Anker), kommt kein Ereignis. Deshalb zusaetzlich beim Scrollen pruefen, per rAF gedrosselt.
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(check, { threshold: 0 }); io.observe(anchor); }
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; check(); });
    }, { passive: true });
    check();
    return bar;
  }

  // Die Pille verkauft dieselbe Menge wie die Stufenwahl in der Kaufbox
  function syncStickyQty(bar, n) {
    if (!bar) return;
    const formEl = bar.querySelector('form');
    if (!formEl) return;
    let q = formEl.querySelector('input[name="quantity"]');
    if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; formEl.appendChild(q); }
    q.value = String(n || 1);
  }

  function resetState() {
    state.f1 = null; state.sex = null; state.f2 = null;
    state.f3 = []; state.f4 = { fish: null, sun: null, diet: null };
    state.f5 = null; state.f6 = null;
    try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* still */ }
  }

  function renderResult(opts) {
    opts = opts || {};
    clearRoot();
    root.classList.add('ff-quiz--result');
    if (stage) stage.classList.add('is-result');
    const r = computeResult();
    const RES = T.result;
    track('ff-quiz:complete', {
      cluster: state.f1,
      f2: state.f1 && state.f2 ? state.f1 + state.f2 : null,
      hero: r.heroProduct || null,
      supplement: r.supplement ? r.supplement.product : null,
      pregnancy: !!r.pregnancy,
      covered: !!r.covered,
      redirected: !!r.redirected
    });
    const screen = el('div', 'ff-quiz-screen ff-quiz-result');
    const pathId = r.f2id || (state.f1 && state.f2 ? state.f1 + state.f2 : null);

    if (opts.saved) screen.appendChild(el('p', 'ff-quiz-saved alert alert--success', T.email.success));

    // Kopf: Eyebrow = Zahl der Fragen, "Dein Ergebnis"
    const head = el('div', 'ff-quiz-result-head');
    const n = sequence().length;
    const numWord = RES['num_' + n] || String(n);
    if (RES.eyebrow) head.appendChild(el('p', 'ff-eyebrow', fill(RES.eyebrow, { C: numWord })));
    const resultHeadline = el('h2', 'ff-quiz-result-title', RES.headline || T.ui.result_header);
    head.appendChild(resultHeadline);
    screen.appendChild(head);

    // Einstieg: wechselnder Auftakt + persoenlicher Auswertungstext, dann "Was oft dahintersteckt"
    const intro = module(null, null, 'intro');
    let bildText = (pathId && T.bild[pathId]) || '';
    if (bildText && r.meno) bildText += ' ' + T.bild.meno_addon;
    if (bildText) {
      // Schwangerschaft/Stillzeit: kein Auftakt-Satz, sondern "Du sagst: ..." und die Ueberleitung zur Lebensphase (Georg)
      const lead = r.pregnancy
        ? [RES.preg_opener, bildText, RES.preg_also].filter(Boolean).join(' ')
        : [openerFor(), bildText].filter(Boolean).join(' ');
      intro.appendChild(el('p', 'ff-quiz-lead', lead));
    }
    const sys = !r.pregnancy && state.f1 ? T.support['sys_' + state.f1] : null;
    if (sys) {
      const behind = el('div', 'ff-quiz-behind');
      behind.appendChild(el('h4', 'ff-quiz-subtitle', RES.label_why));
      behind.appendChild(el('p', 'ff-quiz-text', sys));
      intro.appendChild(behind);
    }
    screen.appendChild(intro);

    let heroBand = null;
    let bar = null;

    if (r.pregnancy) {
      const preg = module(RES.label_preg, RES.headline_preg, 'callout');
      // Reihenfolge (Georg): Einordnung, Bedarfe, dann Omega-3 positiv, System, Wiederkommen
      [T.support.or_preg, RES.preg_why, RES.preg_omega, RES.preg_products, RES.preg_after].forEach(function (t) {
        if (t) preg.appendChild(el('p', 'ff-quiz-text', t));
      });
      const links = el('div', 'ff-quiz-cta-row');
      const pulseUrl = T.url && T.url.pulse;
      if (pulseUrl) links.appendChild(themeButton(fill(T.ui.more_product || '', { P: PRODUCT_NAMES.pulse }), 'button--primary', { class: 'ff-quiz-link', href: pulseUrl }));
      links.appendChild(themeButton(T.ui.back_home, pulseUrl ? 'button--secondary' : 'button--primary', { class: 'ff-quiz-link', href: '/' }));
      preg.appendChild(links);
      screen.appendChild(preg);
    } else if (r.covered) {
      const cov = module(RES.chapter_solution, RES.headline_covered, 'callout');
      cov.appendChild(el('p', 'ff-quiz-text', RES.f6_covered));
      const links = el('div', 'ff-quiz-cta-row');
      links.appendChild(themeButton(T.ui.more_products, 'button--primary', { class: 'ff-quiz-link', href: RES.compare_url || '/collections/all' }));
      cov.appendChild(links);
      screen.appendChild(cov);
    } else {
      const heroName = PRODUCT_NAMES[r.heroProduct];
      const heroLead = r.redirected
        ? [fill(RES.f6_redirect, { P: heroName }), RES.redirect && RES.redirect[r.heroProduct]].filter(Boolean).join(' ')
        : (RES.lead && RES.lead[pathId]) || '';
      heroBand = productBand(r.heroProduct, {
        eyebrow: RES.chapter_solution,
        lead: heroLead,
        modules: r.heroModules,
        why: whyBlock(r, pathId),
        onQty: function (qty) { syncStickyQty(bar, qty); }
      });
      screen.appendChild(heroBand);

      // Story auf Seasalt zwischen den Baendern (Georg: kein weisser Streifen, Nr. 2 schliesst nahtlos an)
      const story = storyFor(r.heroProduct);
      if (story) {
        const storyBand = el('section', 'ff-quiz-band ff-quiz-band--story');
        const storyInner = el('div', 'ff-quiz-band-inner');
        storyInner.appendChild(story);
        storyBand.appendChild(storyInner);
        screen.appendChild(storyBand);
      }

      // Empfehlung Nr. 2: gleicher Aufbau, Einstieg je nach Ausloeser (Zweitthema, Alltag, Pfad, Lebensphase).
      // Die Alltags-Angabe traegt ihren Produktsatz selbst; sonst die Bruecke, mit Held-Variante, wenn es eine gibt.
      if (r.supplement) {
        const sp = r.supplement;
        let introKey = 'add_intro';
        if (sp.meno || sp.source === 'meno') introKey = 'add_intro_meno';
        else if (sp.source === 'reality') introKey = 'add_intro_reality';
        else if (sp.source === 'path') introKey = 'add_intro_path';
        const parts = [fill(RES[introKey] || RES.add_intro || '', { H: heroName })];
        const realities = (r.reality || []).filter(function (rk) { return REALITY_PRODUCT[rk] === sp.product && RES[rk]; });
        if (sp.meno) parts.push(RES.suppl_bridge_meno);
        else if (realities.length) realities.forEach(function (rk) { parts.push(RES[rk]); });
        else parts.push(RES['suppl_bridge_' + sp.product + '_' + r.heroProduct] || RES['suppl_bridge_' + sp.product]);
        screen.appendChild(productBand(sp.product, {
          secondary: true,
          eyebrow: RES.add_eyebrow || RES.chapter_add,
          lead: fill(parts.filter(Boolean).join(' '), { H: heroName }),
          modules: sp.modules
        }));
      }
    }

    // Ehrliche Einordnung: Arzt-Hinweise, Eisen, Wechseljahre
    if ((r.honest && r.honest.length) || r.meno) {
      const honest = module(RES.label_honest, null, 'honest');
      (r.honest || []).forEach(function (key) { honest.appendChild(el('p', 'ff-quiz-text', T.support[key])); });
      if (r.meno) honest.appendChild(el('p', 'ff-quiz-text', RES.meno_frame));
      screen.appendChild(honest);
    }

    // Abschluss wie im Entwurf: Ergebnis speichern | Nicht sicher? (Textlinks, Buttons nur fuer Warenkorb und E-Mail)
    const close = el('section', 'ff-quiz-close');
    const emailEl = r.pregnancy ? null : emailBlock(r, { label: RES.save_label, text: RES.save_text, submit: RES.save_submit });
    if (emailEl) close.appendChild(emailEl);
    if (!r.pregnancy) {
      const unsure = el('div', 'ff-quiz-unsure');
      unsure.appendChild(el('h3', 'ff-quiz-close-title', RES.unsure_label));
      if (RES.unsure_text) unsure.appendChild(el('p', 'ff-quiz-text', RES.unsure_text));
      const links = el('p', 'ff-quiz-textlinks');
      const restartLink = el('a', 'ff-quiz-textlink', RES.unsure_restart || T.ui.restart);
      restartLink.href = window.location.pathname;
      restartLink.addEventListener('click', function (e) { e.preventDefault(); resetState(); renderStart(); });
      links.appendChild(restartLink);
      const compare = el('a', 'ff-quiz-textlink', RES.unsure_compare || T.ui.more_products);
      compare.href = RES.compare_url || '/collections/all';
      links.appendChild(compare);
      unsure.appendChild(links);
      close.appendChild(unsure);
    }
    if (close.childElementCount) screen.appendChild(close);

    const disclaimer = module(null, null, 'disclaimer');
    disclaimer.appendChild(el('p', 'ff-quiz-disclaimer', T.support.dis_journal));
    screen.appendChild(disclaimer);

    if (r.pregnancy) {
      const restart = el('button', 'ff-quiz-restart', T.ui.restart);
      restart.type = 'button';
      restart.addEventListener('click', function () { resetState(); renderStart(); });
      screen.appendChild(restart);
    }

    if (heroBand) {
      bar = stickyBuy(r.heroProduct, heroBand.ffBuybox || heroBand);
      if (bar) {
        const q = heroBand.querySelector('[data-ff-tier-qty]');
        syncStickyQty(bar, q ? parseInt(q.value, 10) || 1 : 1);
        screen.appendChild(bar);
      }
    }
    mountScreen(screen, resultHeadline);
  }

  // Neustart: kein Start-Screen mehr (Fullscreen-Check), zurueck zu Intro + Frage 1
  function renderStart() {
    root.classList.remove('ff-quiz--result');
    track('ff-quiz:start', { source: 'restart' });
    renderQuestion('f1');
  }

  // Einstieg: Die Seite ist der Check (Georg 2026-09-10). Frage 1 sofort; ?f1=a..e (Teaser, Kampagnen)
  // beantwortet Frage 1 und zeigt Frage 2. Ungueltige Werte werden ignoriert.
  let preset = null;
  let shared = null;
  try {
    const q = new URLSearchParams(window.location.search);
    const p = q.get('f1'); if (p && /^[a-e]$/.test(p)) preset = p;
    shared = q.get('r');
  } catch (e) { /* still */ }
  if (shared && decodeState(shared)) {
    // Ergebnis-Link (z. B. aus der Klaviyo-Mail): direkt das Ergebnis, kein E-Mail-Schritt
    track('ff-quiz:start', { source: 'result_link' });
    renderResult();
  } else if (preset) {
    setAnswer('f1', preset);
    track('ff-quiz:start', { source: 'teaser', f1: preset });
    advance('f1');
  } else {
    track('ff-quiz:start', { source: 'page' });
    renderQuestion('f1');
  }
})();
